<template>
  <o-form-wrapper v-model="item" :form-state="formState" :schema="schema" :server-errors="_se" :v="$v.item">
    <o-widget-wrapper :form-state="formState" :schema="schema" :server-errors="_se" :validators="$v.item"
                      name="product">
      <o-select
        v-model="item.product"
        :form-state="formState"
        :items="optionCodeProductItems"
        :loading="optionCodeProductWorking"
        :server-errors="_se"

        :validators="$v.item"
        add-title="Create New"
        allow-add name="product" sort-field="description" store-name="CodeProduct"

        text-field="description"
        v-bind="schema.fields.product"
        value-field="id"
      >
        <template slot="form" slot-scope="{item, formState, serverErrors}">
          <code-product-form :form-state="formState" :item="item" :server-errors="serverErrors"
                             in-modal></code-product-form>
        </template>
      </o-select>
    </o-widget-wrapper>

    <o-widget-wrapper :form-state="formState" :schema="schema" :server-errors="_se" :validators="$v.item"
                      name="ordered_quantity">
      <o-text-field
        v-model="item.ordered_quantity"

        :form-state="formState"
        :server-errors="_se" :validators="$v.item" name="ordered_quantity"
        v-bind="schema.fields.ordered_quantity"
      ></o-text-field>
    </o-widget-wrapper>

  </o-form-wrapper>
</template>

<script>
import schema from "../../schema/index";
import {cleanUpModel} from "../../../vue-ocom/schema/schema_vuetify";
import {
  CreateCodeTableFetchMixin,
  CreateFormStateMixin,
  CreateGroupPermissionMixin,
  VuelidateMixin
} from '../../../vue-ocom/mixins'
import {validationMixin} from 'vuelidate'
import OWidgetWrapper from "../../../vue-ocom/components/forms/OWidgetWrapper";
import OTextField from "../../../vue-ocom/components/forms/fields/OTextField";
import OSelect from "../../../vue-ocom/components/forms/fields/OSelect";
import OCheckbox from "../../../vue-ocom/components/forms/fields/OCheckbox";
import OFormWrapper from "../../../vue-ocom/components/forms/OFormWrapper";
import ODateTime from "../../../vue-ocom/components/forms/fields/ODateTime";

import {default as CodeProductForm} from '../../code_product/components/ItemForm';

export default {
  mixins: [VuelidateMixin,
    validationMixin,
    CreateFormStateMixin('$v'),
    CreateGroupPermissionMixin('JobProduct'),
    CreateCodeTableFetchMixin(['CodeProduct',])
  ],
  components: {
    OFormWrapper,
    OWidgetWrapper,
    ODateTime,

    OCheckbox,
    OSelect,
    OTextField,

    CodeProductForm,
  },
  props: {
    item: {
      type: Object, default: () => {
      }
    },
    level: {type: Number, default: 0},
    inModal: {type: Boolean, default: false},
  },
  data: () => ({
    schemaModel: cleanUpModel(schema.JobProduct, {}),
  }),
  methods: {},
  computed: {
    _se() {
      // Return an empty Object if there are no Server Errors to avoid Binding Errors
      return this.serverErrors || {};
    }
  },
  watch: {},
  created() {
  },
}
</script>
